// FETCH ALL EMPLOYEE
export const FETCH_EMPLOYEE_REQUEST = 'FETCH_EMPLOYEE_REQUEST';
export const FETCH_EMPLOYEE_SUCCESS = 'FETCH_EMPLOYEE_SUCCESS';
export const FETCH_EMPLOYEE_FAILURE = 'FETCH_EMPLOYEE_FAILURE';

// CREATE EMPLOYEE
export const CREATE_EMPLOYEE_REQUEST = 'CREATE_EMPLOYEE_REQUEST';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_FAILURE = 'CREATE_EMPLOYEE_FAILURE';

// UPDATE EMPLOYEE
export const UPDATE_EMPLOYEE_REQUEST = 'UPDATE_EMPLOYEE_REQUEST';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_FAILURE = 'UPDATE_EMPLOYEE_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_EMPLOYEE_REQUEST = 'FETCH_SINGLE_EMPLOYEE_REQUEST';
export const FETCH_SINGLE_EMPLOYEE_SUCCESS = 'FETCH_SINGLE_EMPLOYEE_SUCCESS';
export const FETCH_SINGLE_EMPLOYEE_FAILURE = 'FETCH_SINGLE_EMPLOYEE_FAILURE';

// DELETE EMPLOYEE
export const DELETE_EMPLOYEE_REQUEST = 'DELETE_EMPLOYEE_REQUEST';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';
export const DELETE_EMPLOYEE_FAILURE = 'DELETE_EMPLOYEE_FAILURE';

export const RESET_EMPLOYEE_INFO = 'RESET_EMPLOYEE_INFO';

export const CREATE_EMPLOYEE_FORM = 'CREATE_EMPLOYEE_FORM';

export const UPDATE_EMPLOYEE_FORM = 'UPDATE_EMPLOYEE_FORM';
